module.exports = fox._r("fonts/ropasoftpro-regular-webfont.ttf", __webpack_public_path__ + "fonts/16N7zDj.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/ropasoftpro-regular-webfont.ttf
// module id = 962
// module chunks = 4